import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mx8mk6w8xb: FaireBrandEntity = {
  token: "b_mx8mk6w8xb",
  type: "brand",
  name: "Scout Trading Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/809c84155e6f720886ac8e28563cdbeb0293c57c56d63b49d7c7aadd86dda384.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/41d72a9aa92edde72f85a70da6c5b9fe0e2aa0bd3c71cb5f7fb90eb41d84dd4d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/809c84155e6f720886ac8e28563cdbeb0293c57c56d63b49d7c7aadd86dda384.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/41d72a9aa92edde72f85a70da6c5b9fe0e2aa0bd3c71cb5f7fb90eb41d84dd4d.jpeg",
  location: "Cedarburg , WI, USA",
  minimumOrderDollars: 62,
  rating: 5,
  reviewCount: 5,
  isTopShop: true,
  isInsider: true,
  description:
    "Not your Grandma’s dipping sauce. But actually, it is. \n\n2 flavors from original family recipes in the Midwest.\n\nScout Original is a uniquely sweet dipping sauce that works well with pretzels, charcuterie, ham sandwich, Bloody Mary, brat, hot dog, cocktail weenie, fries, ingredient for a recipe — it’s a tasty and versatile dipping sauce!\n\nScout Campfire has a smoky flavor with a chipotle kick.  It is perfect for tendies, sandwiches, fries, burgers and much more!",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:08.223Z",
    importedBy: "entity-db-cli",
  },
};
